import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-divisiones',
  templateUrl: './divisiones.component.html',
  styleUrls: ['./divisiones.component.scss']
})
export class DivisionesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
